import { AVAILABILITY_BASE_PATH } from 'constants/sharedConstants';
import { useMutation } from 'react-query';
import { useApi } from 'utils/api';
import tracking from 'utils/tracking';
import { useSelector } from 'react-redux';
import { Store } from 'types/store';
import { AxiosError } from 'axios';
import { GuestAppointmentResponse } from '../types';
import { GUEST_APPOINTMENT_KEY, GUEST_APPOINTMENT_TAG } from '../constants';
import { getQueryKey, updateQueryData } from '../utils';

export type UpdateGuestAppointmentParams = {
  guestAppointmentId: string;
  appointmentId?: number;
  patientId?: number;
  isDeleted?: boolean;
  startsAt?: string;
};

export const useUpdateGuestAppointment = () => {
  const api = useApi();
  const patientId = useSelector((store: Store) => store?.global_reducer?.current_user?.attributes?.patient?.id);

  const updateGuestAppointment = async ({ guestAppointmentId, ...params }: UpdateGuestAppointmentParams) => {
    const requestBody = Object.entries(params).reduce<Record<string, unknown>>((result, [key, value]) => {
      if (value !== undefined && value !== null) {
        result[key] = value;
      }
      return result;
    }, {});

    const response = await api.patch<GuestAppointmentResponse>(
      `/guest-appointments/${guestAppointmentId}`,
      requestBody,
      {
        baseURL: AVAILABILITY_BASE_PATH
      }
    );
    return response.data;
  };

  return useMutation({
    mutationFn: updateGuestAppointment,
    onSuccess: data => {
      sessionStorage.removeItem(GUEST_APPOINTMENT_KEY);
      const queryKey = getQueryKey({ patientId });
      updateQueryData(queryKey, data);
    },
    onError: (err, params) => {
      tracking.errorV2('Failed to update the guest appointment', err, {
        tags: [GUEST_APPOINTMENT_TAG, 'update'],
        params,
        errorResponse: (err as AxiosError)?.response?.data
      });
    }
  });
};
